const rolesList = {
  User: "user",
  Admin: "admin",
  Demo: "demo",
};

export default rolesList;
